import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { Case } from 'app/backend/salesforce-maps/Case'
import { getExpressionOfInterestCasesByFlow } from 'app/backend/selesforce-custom-queries/CaseQueries'
import { ReduxOrganization, ReduxState } from 'app/redux/ReduxInterfaces'
import { useSelector } from 'react-redux'

export const EXPRESSION_OF_INTEREST_APPROVED_OUTCOME = 'Invited to apply for Centre funding'

export const isApprovedExpressionOfInterestCase = (c: Case, caseType?: string): boolean =>
  c.status === 'Closed' &&
  c.type === caseType &&
  c.outcome === EXPRESSION_OF_INTEREST_APPROVED_OUTCOME &&
  c.opportunityId == null

interface ExpressionOfInterestStatus {
  query: UseQueryResult<Case[]>
  approvedCase: Case | undefined
  approvedCaseExists: boolean
  unresolvedCaseExists: boolean
}

/**
 * Expression of interest cases of the current organization, and their status
 * for the funding stream identified by caseType.
 */
export const useExpressionOfInterestStatus = (caseType?: string): ExpressionOfInterestStatus => {
  const organization = useSelector<ReduxState, ReduxOrganization>((state) => state.organization)

  const query = useQuery<Case[]>(['expressionOfInterestCases', organization.id], {
    refetchOnWindowFocus: false,
    enabled: Boolean(organization.id),
    queryFn: async () => await getExpressionOfInterestCasesByFlow(organization.id)
  })

  const approvedCase = query.data?.find((c) => isApprovedExpressionOfInterestCase(c, caseType))

  return {
    query,
    approvedCase,
    approvedCaseExists: approvedCase != null,
    unresolvedCaseExists:
      query.data?.some((c) => c.status !== 'Closed' && c.type === caseType) ?? false
  }
}
